import Decimal from 'decimal.js'
import { GeckoMeasurement } from 'types/measurement/geckoMeasurement'
import { GeckoMeasurementUnit } from 'types/measurement/geckoMeasurementUnit'

/**
 * Weight thickness values (i.e. nominal) to the lower "unit weight" (inches/mm instead of feet/meters) for display purposes
 *
 * This function handles floating point errors for the most common use-case (meters from RAM)
 */
export function weightThicknessValue(
  thicknessMeasurement: GeckoMeasurement
): GeckoMeasurement {
  if (
    thicknessMeasurement.unit === GeckoMeasurementUnit.Millimeters ||
    thicknessMeasurement.unit === GeckoMeasurementUnit.Inches
  ) {
    return thicknessMeasurement
  }

  if (thicknessMeasurement.unit === GeckoMeasurementUnit.Meters) {
    return GeckoMeasurement.CreateFromValue(
      new Decimal(thicknessMeasurement.num).mul(1000).toNumber(),
      GeckoMeasurementUnit.Millimeters
    )
  }
  return thicknessMeasurement.convertTo(GeckoMeasurementUnit.Millimeters)
}
